//必须含大小写字母和数字，不得少于8位
export const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\x20-\x7E]{8,}$/;
